import React, { useState } from "react";

import { DropdownButton, Dropdown } from 'react-bootstrap';
import { selectOptions } from "../../../shared/utility";

const CustomDropdown: React.FC<any> = (props) => {

  const [selected, setSelected] = useState(props.options.find((el:any) => el.default));

  const selectedItems = props.options.map(function(select:any){
    return <Dropdown.Item key={select.key} eventKey={select.key}>{select.value}</Dropdown.Item>;
  })

 React.useEffect(() => {
    if (props.value) {
      const currentValue = props.options.find((el:any) => (el.key === props.value));
      setSelected(currentValue);
    }
  }, [props.options, props.value])

  return (
    <>
      <style type="text/css">
          {`
            .btn-custom-dropdown {
                background-color: transparent;
                color: #000000;
                font-size: 12px;
                border: 1px solid #ced4da;
                border-right-color: transparent;
                border-radius: 0;
            }
            .btn-custom-dropdown:focus-within {
              border-color: #009435;
            }
        `}
        </style>
    <DropdownButton
      as={props.as}
      id={props.id}
      variant="custom-dropdown"
      title={selected.value}
      onSelect={function (evt: any) {
          const currentValue = props.options.find((el:any) => (el.key === evt));
          props.setFieldValue(props.name, currentValue.key);
          if (props.clearOnExact) {
            if (currentValue.key === selectOptions.EXACT) {
              props.setFieldValue(props.clearFieldName, []);
            } else if (Array.isArray(props.clearFieldValue)) {
              props.setFieldValue(props.clearFieldName, "");
            }
          }

          setSelected(currentValue)
        }}>
      {selectedItems}
    </DropdownButton>
    </>
  );
};

export default CustomDropdown;
